import { useState, useEffect, useCallback } from 'react'
import { getPage, post } from '../lib/api'
import type { InterviewScript } from '../types/api'

export function useInterviewScripts(talentId: string) {
  const [scripts, setScripts] = useState<InterviewScript[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [generating, setGenerating] = useState(false)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await getPage<InterviewScript>(
        `/api/v1/talents/${talentId}/interview-scripts`,
      )
      setScripts(res.data)
    } catch (e) {
      setError(e instanceof Error ? e.message : '알 수 없는 오류')
    } finally {
      setLoading(false)
    }
  }, [talentId])

  useEffect(() => {
    load()
  }, [load])

  const generate = useCallback(
    async (company: string, jobMatchId?: string) => {
      setGenerating(true)
      try {
        await post<InterviewScript>(
          `/api/v1/talents/${talentId}/interview-scripts/generate`,
          { company, ...(jobMatchId ? { jobMatchId } : {}) },
        )
        await load()
      } finally {
        setGenerating(false)
      }
    },
    [talentId, load],
  )

  return { scripts, loading, error, reload: load, generate, generating }
}
